import { render, staticRenderFns } from "./ChangeOwner.vue?vue&type=template&id=b8c0c7c6&scoped=true"
import script from "./ChangeOwner.vue?vue&type=script&lang=js"
export * from "./ChangeOwner.vue?vue&type=script&lang=js"
import style0 from "./ChangeOwner.vue?vue&type=style&index=0&id=b8c0c7c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8c0c7c6",
  null
  
)

export default component.exports